import { connect } from 'react-redux';

import XapInterstitial from '../components/XapInterstitial';
import { getCMSPackage } from '../actions/cms';
import { getIsXapCurrent, getIsXapExit, getIsXapExitInProgress } from '../helpers/xap';
import { NEW_PAYMENT, PAYMENT_PLAN } from '../helpers/routes';
import { flagEnabled } from '../helpers/featureFlags';

const mapStateToProps = ({
  account: { loading: accountLoading, account: legacyAccount } = {},
  contextHub: { loading: contextHubLoading, contextHub: contextHubAccount } = {},
  auth: {
    accountPerms = [],
  } = {},
  cms: {
    packages: {
      xapModal: {
        loading = true,
        error,
        content = {},
      } = {},
    } = {},
  },
},
{
  location: { pathname = '' } = {},
}) => {
  // Determine authorized roles based on flow:
  // User API flow uses PRIMARY or MANAGER, Macaroon flow uses PRIMARY or BILLPAY
  const isUserAPIInvoked = flagEnabled('replaceMacaroonApiEnabled');
  const isReplaceAccountApiPhase1Enabled = flagEnabled('replaceAccountApiPhase1Enabled');
  const authorizedRoles = isUserAPIInvoked
    ? ['PRIMARY', 'MANAGER']
    : ['PRIMARY', 'BILLPAY'];
  const hasBilling = accountPerms && accountPerms.some(
    role => authorizedRoles.includes(role),
  );

  const shouldUseContextHub = pathname.startsWith(NEW_PAYMENT)
    && isReplaceAccountApiPhase1Enabled;
  const resolvedAccount = shouldUseContextHub ? contextHubAccount : legacyAccount;
  const isXapCurrent = getIsXapCurrent(resolvedAccount) && !getIsXapExitInProgress(resolvedAccount);
  const isXapExit = flagEnabled('global.xapExitEnabled') && getIsXapExit(resolvedAccount);

  const eligible = (
    flagEnabled('global.xapInterstitial')
    // Don't show the XAP current/exit modals in the payment plan flow
    && !pathname.startsWith(PAYMENT_PLAN)
    && hasBilling
    && (isXapCurrent || isXapExit)
  );

  let cmsPackage;
  if (isXapExit) {
    cmsPackage = 'xap-exit-modal';
  } else if (isXapCurrent) {
    cmsPackage = 'xap-current-modal';
  }

  const {
    heading,
    description,
    cta: ctas = [],
    pairs: metadata = [],
  } = content;

  const primaryCta = ctas.find(cta => cta.type === 'primary');
  const secondaryCta = ctas.find(cta => cta.type === 'secondary');

  const componentName = metadata.find((item = {}) => item.key === 'adobeComponentName');
  const dismissedCookieName = metadata.find((item = {}) => item.key === 'dismissedCookieName');
  const resolvedAccountLoading = shouldUseContextHub
    ? contextHubLoading : accountLoading;

  return {
    eligible,
    cmsPackage,
    loading: (loading || resolvedAccountLoading) && !error,
    accountLoading: resolvedAccountLoading,
    content: {
      heading,
      description,
      primaryCta,
      secondaryCta,
      placementName: 'xap-interstitial',
      componentName: componentName && componentName.value,
      dismissedCookieName: dismissedCookieName && dismissedCookieName.value,
    },
  };
};

const mapDispatchToProps = dispatch => ({
  handleGetCopy: packageName => dispatch(getCMSPackage(packageName, { storeKey: 'xapModal' })),
});

export default connect(mapStateToProps, mapDispatchToProps)(XapInterstitial);
